import { useTranslation } from "react-i18next";
import type { ScheduleEntry } from "../../lib/realestate";
import { TimeSeriesLineChart } from "../charts/TimeSeriesLineChart";

interface Props {
  schedule: ScheduleEntry[];
}

export function RemainingDebtChart({ schedule }: Props) {
  const { t } = useTranslation();
  // Aggregiere auf Jahres-Endwerte: pro Jahr den letzten verfuegbaren Eintrag
  const byYear = new Map<number, ScheduleEntry>();
  for (const entry of schedule) {
    const year = new Date(entry.date).getUTCFullYear();
    const prev = byYear.get(year);
    if (!prev || new Date(entry.date).getTime() > new Date(prev.date).getTime()) {
      byYear.set(year, entry);
    }
  }
  const data = Array.from(byYear.entries())
    .sort(([a], [b]) => a - b)
    .map(([year, entry]) => ({
      date: `${year}-12-31`,
      valueCents: entry.principalAtEnd,
    }));

  if (data.length === 0) {
    return <p className="text-sm text-slate-500">{t("realestate.amortization.no_data")}</p>;
  }

  return <TimeSeriesLineChart data={data} />;
}
